import { useEffect, useState } from "react";
import { tEnglish as t } from "@buza/i18n";
import { api, type ZdSession } from "./api.js";
import { OpsInbox } from "./ops/OpsInbox.js";
import { Prices } from "./prices/Prices.js";
import { Invoices } from "./invoices/Invoices.js";
import { ConsoleShell, type ScreenDef } from "./shell/ConsoleShell.js";
import { SignIn } from "./SignIn.js";
import { Tenants } from "./Tenants.js";

// ZD console. Z01 sign-in guards every other screen. After sign-in the shell (S-062) shows the
// signed-in user, the navigation and the tenant bar on every screen (ENT-06): Z02 Tenants (S-041)
// and Z06 Operations inbox (S-062). Z03 to Z08 add a screen here as their stories land.
// Every phrase comes from a key (TRN-01).
export function App() {
  const [session, setSession] = useState<ZdSession | null | undefined>(undefined);

  useEffect(() => {
    document.title = t("console.shell.app_name");
    void api<ZdSession>("/v1/zd/session").then((r) => setSession(r.ok ? r.data : null));
  }, []);

  if (session === undefined) return <main aria-busy="true" />;
  if (session === null) return <SignIn onSignedIn={setSession} />;

  async function signOut() {
    await api("/v1/zd/session", { method: "DELETE" });
    setSession(null);
  }

  const screens: ScreenDef[] = [
    { id: "tenants", label: "console.common.nav_tenants", render: () => <Tenants role={session.role} /> },
    { id: "ops", label: "console.common.nav_ops", render: () => <OpsInbox me={session.zdUserId} /> },
    // S-050 prices section of Z03 and Z04 (the full screens are S-046 and S-051).
    { id: "prices", label: "console.prices.nav", render: () => <Prices /> },
    // S-051 Z04 Payments and credits: invoices, mark paid, cancel.
    { id: "invoices", label: "console.invoices.nav", render: () => <Invoices /> },
  ];
  return <ConsoleShell session={session} screens={screens} onSignOut={signOut} />;
}
